import { TextBoxMultipleOutlineIcon } from './TextBoxMultipleOutlineIcon';

/**
 * author: Austin Andrews
 * id 02EF54D9-4D5D-463C-A3E8-0B44BDCB9523
 * name text-box-multiple-outline
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-box-multiple-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileDocumentBoxesOutlineIcon = TextBoxMultipleOutlineIcon;
export default FileDocumentBoxesOutlineIcon